/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingStyleModule_contemporaryLandingRow$ref: FragmentReference;
export type ContemporaryLandingStyleModule_contemporaryLandingRow = {|
  +items: ?$ReadOnlyArray<?{|
    +text?: ?string,
    +type?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +description?: ?string,
      +imagePath?: ?string,
      +title?: ?string,
      +url?: ?string,
    |}>,
  |}>,
  +$refType: ContemporaryLandingStyleModule_contemporaryLandingRow$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContemporaryLandingStyleModule_contemporaryLandingRow",
  "type": "ContemporaryLandingRow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingRow",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "ContemporaryLandingStyleRowItem",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "description",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imagePath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "url",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingHeader",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'acf2d700da634fd84dc525065cfc405b';
module.exports = node;
